// components/InteractiveToast.tsx
import React from 'react';
import toast from 'react-hot-toast';
import InteractiveToastContent from './InteractiveTostContent';
interface InteractiveToastProps {
  message: string;
  onConfirm?: () => void;
}

const showInteractiveToast = ({
  message,
  onConfirm,
}: InteractiveToastProps) => {
  toast.custom(
    (t) => (
      <InteractiveToastContent
        message={message}
        onConfirm={onConfirm}
        toastId={t.id}
      />
    ),
    {
      duration: Infinity,
      position: 'top-center',
    }
  );
};

export default showInteractiveToast;
